







import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";

@Component({
  components: {}
})
export default class TelephoneNumbers extends Vue {
}
